import React from "react";

export default function Function()
{
    return (
        <footer className="fixed-bottom hg-70">
            <div className="ground-container">
                <div className="ground"></div>
            </div>
            <div className="container-fluid row text-center hg-100">
                <div className="col-2 align-self-center">
                    <h6 className="c-light-2 m-auto">contact@magikusstudios.com</h6>
                </div>
                <div className="col-8 align-self-center"></div>
                <div className="col-2 align-self-center">
                    <a href="/#/about" className="c-light-2 t-dec-none c-light-3-h">
                        <h5 className="m-auto">About</h5>
                    </a>
                </div>
            </div>
        </footer>
    );
}